export type Theme = 'dark' | 'light';

const THEME_COOKIE = 'supersimple-theme';
const THEME_PARAM = 'theme';

export function getTheme(): Theme {
  // 1. Query param (highest priority, for previewing/sharing)
  const params = new URLSearchParams(window.location.search);
  const paramTheme = params.get(THEME_PARAM);
  if (paramTheme === 'light' || paramTheme === 'dark') {
    return paramTheme;
  }

  // 2. Cookie
  const match = document.cookie.match(new RegExp(`${THEME_COOKIE}=([^;]+)`));
  if (match) {
    const value = match[1];
    if (value === 'light' || value === 'dark') {
      return value;
    }
  }

  // 3. Default
  return 'dark';
}

export function setTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  document.cookie = `${THEME_COOKIE}=${theme};path=/;max-age=${365 * 24 * 60 * 60}`;
}

export function initTheme(): void {
  setTheme(getTheme());
}
